import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';

import '@angular/material/prebuilt-themes/indigo-pink.css'
import './styles/style.css';

import "./favicon.ico";

if (process.env.ENV === 'production') {
  enableProdMode();
} else {
  // Development and test
  Error['stackTraceLimit'] = Infinity;
  require('zone.js/dist/long-stack-trace-zone');
}

platformBrowserDynamic().bootstrapModule(AppModule);
